var progress_rate = "10";
var urlParams = new URLSearchParams(window.location.search);
  var inputVal = urlParams.get('input');
  if (inputVal) {
    var decodedInput = decodeURIComponent(inputVal);
    $('#dogNameInput-0').val(decodedInput);
    $(".dog-name").removeClass("stickynavigation-module__disabled___1GDwt");
    $(".dog-name").find("button").removeAttr("disabled");
    Cookies.set("dogName", decodedInput, { expires: 7 });
}
$("input#dogNameInput-0").on("input", function() {
  var dog_id = $(this).attr("id");
  var dog_name = $(this).val();
  if ($(this).val() != "") {
    $(".dog-name").removeClass("stickynavigation-module__disabled___1GDwt");
    $(".dog-name").find("button").removeAttr("disabled");
  } else {
    $(".dog-name").addClass("stickynavigation-module__disabled___1GDwt");
    $(".dog-name").find("button").attr("disabled","");
  }
})

$("input#areaNameInput-0").on("input", function() {
  if ($(this).val() != "") {
    $(".area-name").removeClass("stickynavigation-module__disabled___1GDwt");
    $(".area-name").find("button").removeAttr("disabled");
  } else {
    $(".area-name").addClass("stickynavigation-module__disabled___1GDwt");
    $(".area-name").find("button").attr("disabled","");
  }
})

var current_fs, next_fs, previous_fs; //fieldsets
var left, opacity, scale; //fieldset properties which we will animate
var animating; //flag to prevent quick multi-click glitches

$(".next").click(function(){
	if(animating) return false;
	animating = false;
	
	current_fs = $(this).parents("section.subscription-step");
	next_fs = $(this).parents("section.subscription-step").next();
	
	//activate next step on progressbar using the index of next_fs
	//$("#stepbar li").eq($(".subscription-step").index(next_fs)).addClass("active");
	next_fs.addClass("active");
    current_fs.removeClass("active");
	//show the next fieldset
	next_fs.css("display","flex");
	//hide the current fieldset with style
	current_fs.animate({opacity: 0}, {
		step: function(now, mx) {
			//as the opacity of current_fs reduces to 0 - stored in "now"
			//1. scale current_fs down to 80%
			scale = 1 - (1 - now) * 0.2;
			//2. bring next_fs from the right(50%)
			left = (now * 50)+"%";
			//3. increase opacity of next_fs to 1 as it moves in
			opacity = 1 - now;
			current_fs.css({
       // 'transform': 'scale('+scale+')',
        'position': 'relative'
      });
			next_fs.css({'left': left, 'opacity': opacity});
		}, 
		duration: 10, 
		complete: function(){
			current_fs.hide();
			animating = false;
		}
	});
});

$(".previous").click(function(){
	if(animating) return false;
	animating = false;
	
	current_fs = $(this).parents("section.subscription-step");
	previous_fs = $(this).parents("section.subscription-step").prev();
	
	//de-activate current step on progressbar
	//$("#stepbar li").eq($(".subscription-step").index(current_fs)).removeClass("active");
	
	//show the previous fieldset
	// previous_fs.show(); 
    previous_fs.css("display", "flex");
	//hide the current fieldset with style
	current_fs.animate({opacity: 0}, {
		step: function(now, mx) {
			//as the opacity of current_fs reduces to 0 - stored in "now"
			//1. scale previous_fs from 80% to 100%
			scale = 0.8 + (1 - now) * 0.2;
			//2. take current_fs to the right(50%) - from 0%
			left = ((1-now) * 50)+"%";
			//3. increase opacity of previous_fs to 1 as it moves in
			opacity = 1 - now;
			current_fs.css({'left': left});
			previous_fs.css({
            //  'transform': 'scale('+scale+')', 
              'opacity': opacity});
          previous_fs.addClass("active");
          current_fs.removeClass("active");
		}, 
		duration: 10, 
		complete: function(){
			current_fs.hide();
			animating = false;
		}
	});
});
$("input[name=dog-0-gender]").click(function() {
  var dog_gender = $(this).val();
  if($("input[name=dog-0-gender").is(":checked")) {
    $(".neutered").removeClass("hidden");
  }
  if (dog_gender == "female") {
    $(".gender-module__subQuestion___34f7n h1.text-module__display28___zoDdI.text-module__scale___3IzpA").text("¿Está ligada?");
  } else {
    $(".gender-module__subQuestion___34f7n h1.text-module__display28___zoDdI.text-module__scale___3IzpA").text("¿Es castrado?");
  }
})
$("input[name=dog-0-desexed]").click(function() {
  var neutered_val = $(this).val();
  if($("input[name=dog-0-desexed").is(":checked")) {
    $(".gender-step").removeClass("stickynavigation-module__disabled___1GDwt");
    $(".gender-step").find("button").removeAttr("disabled","");
  }
  if(neutered_val == "no") {
    $(".neutered-info").removeClass("hidden");
  } else {
    $(".neutered-info").addClass("hidden");
  }
})
function updateDogAgeAccessibility() {
  var ageStageSelected = $("input[name=dog-0-ageStage]:checked").val() !== undefined;
  var ageInputFilled = $("input.birth-date").filter(function() { return this.value !== ""; }).length > 0;

  if (ageStageSelected) {
    $(".dog-age").removeClass("stickynavigation-module__disabled___1GDwt");
    $(".dog-age").find("button").removeAttr("disabled");
  } else {
    $(".dog-age").addClass("stickynavigation-module__disabled___1GDwt");
    $(".dog-age").find("button").attr("disabled", "disabled");
  }
}


$("input[name=dog-0-ageStage]").on("click", function() {
  var age_value = $(this).val();
  if (age_value === "puppy") {
    $(".fl").addClass("age-module__confetto___faAp3");
    $(".puppy-checkbox").removeClass("hidden");
    $(".puppy-speech").removeClass("hidden");
  } else {
    $(".fl").removeClass("age-module__confetto___faAp3");
    $(".puppy-checkbox").addClass("hidden");
    $(".puppy-speech").addClass("hidden");
  }

  updateDogAgeAccessibility(); 
});

$("input.birth-date").on("input", function() {
  updateDogAgeAccessibility(); 
});
let roundedAge = 0;
function setMaxDate() {
  const today = new Date().toISOString().split('T')[0];
  document.querySelector('.birth-date').setAttribute('max', today);
}
setMaxDate();
document.querySelector('.birth-date').addEventListener('change', function() {
  const birthDate = new Date(this.value);
  const today = new Date();

  let years = today.getFullYear() - birthDate.getFullYear();
  let months = today.getMonth() - birthDate.getMonth();
  let days = today.getDate() - birthDate.getDate();

  if (days < 0) {
    months--;
    days += new Date(today.getFullYear(), today.getMonth(), 0).getDate();
  }

  if (months < 0) {
    years--;
    months += 12;
  }

  // Consider any remaining days as a full month
  if (days > 0) {
    months++;
  }

  const ageInFullMonths = (years * 12) + months;
  roundedAge = (ageInFullMonths / 12).toFixed(2);
  
});




// Handles click on the main breed input to show the selector
$(".breed-input").click(function() {
  $(".breed-selector").removeClass("hidden");
});

// Handles click on the cross-breed input to show its selector
$(".cross-breed-input").click(function() {
  $(".breed-selector1").removeClass("hidden");
});

// Handles selection of a dog breed from the first list
$(document).on('click', "li[role=option]", function() {
  var dog_breed = $(this).text(); // Get the selected breed text
  $("input#downshift-3-input").val(dog_breed); // Set the input field value
  $(".breed-selector").addClass("hidden"); // Hide the breed selector
  $(".dog-breed").removeClass("stickynavigation-module__disabled___1GDwt"); // Enable the dog-breed section
  $(".dog-breed").find("button").removeAttr("disabled", ""); // Enable the button within dog-breed
});

// Handles selection of a dog breed from the second list (cross-breed)
$(document).on('click', "li[role=option1]", function() {
  var dog_breedd = $(this).text(); // Get the selected cross-breed text
  $("input#downshift-3-input1").val(dog_breedd); // Set the cross-breed input field value
  $(".breed-selector1").addClass("hidden"); // Hide the cross-breed selector
});

// Toggles the visibility of the breed container based on the "unknown breed" checkbox
$(".unknown-breed").click(function() {
  if($(this).is(":checked")) {
    $(".breed-container").addClass("hidden"); // Hide if checked
  } else {
    $(".breed-container").removeClass("hidden"); // Show if unchecked
  }
});

// NEW: Add an input event listener to the breed input field
// This removes the disabled class and enables the button when text is typed.
$("input#downshift-3-input").on('input', function() {
  // Check if the input field has any value
  if ($(this).val().trim() !== "") {
    $(".dog-breed").removeClass("stickynavigation-module__disabled___1GDwt"); // Remove the disabled class
    $(".dog-breed").find("button").removeAttr("disabled", ""); // Enable the button
  } else {
    // Optionally, if you want to re-disable when the field is empty, uncomment the lines below
    // $(".dog-breed").addClass("stickynavigation-module__disabled___1GDwt");
    // $(".dog-breed").find("button").attr("disabled", "disabled");
  }
});

// NEW: Add an input event listener to the cross-breed input field
// This also removes the disabled class and enables the button when text is typed.
$("input#downshift-3-input1").on('input', function() {
  // Check if the input field has any value
  if ($(this).val().trim() !== "") {
    $(".dog-breed").removeClass("stickynavigation-module__disabled___1GDwt"); // Remove the disabled class
    $(".dog-breed").find("button").removeAttr("disabled", ""); // Enable the button
  } else {
    // Optionally, if you want to re-disable when the field is empty, uncomment the lines below
    // $(".dog-breed").addClass("stickynavigation-module__disabled___1GDwt");
    // $(".dog-breed").find("button").attr("disabled", "disabled");
  }
});






$("input[name=dog-0-food], input[name=dog-eating-habit]").on('change', function() {
  if ($("input[name=dog-0-food]").is(":checked") && $("input[name=dog-eating-habit]").is(":checked")) {
    $(".dog-eating-habit").removeClass("stickynavigation-module__disabled___1GDwt");
    $(".dog-eating-habit").find("button").removeAttr("disabled","");
  } else {
    $(".dog-eating-habit").addClass("stickynavigation-module__disabled___1GDwt");
    $(".dog-eating-habit").find("button").attr("disabled","");
  }
})

$("input[name=dog-body], input[name=dog-activity]").on('change', function() {
  if ($("input[name=dog-body]").is(":checked") && $("input[name=dog-activity]").is(":checked")) {
    $(".dog-body-type").removeClass("stickynavigation-module__disabled___1GDwt");
    $(".dog-body-type").find("button").removeAttr("disabled","");
  } else {
    $(".dog-body-type").addClass("stickynavigation-module__disabled___1GDwt");
    $(".dog-body-type").find("button").attr("disabled","");
  }
})


$("input[name=dog-f-note]").click(function() {
  $(".dog-food-note").removeClass("stickynavigation-module__disabled___1GDwt");
  $(".dog-food-note").find("button").removeAttr("disabled","");
})
$(".dog-bodyshape").click(function() {
  $(".dog-bodyshape").removeClass("bodyshape-module__selected___3RSmv");
  $(this).addClass("bodyshape-module__selected___3RSmv");
  var dog_bodyshape = $(this).attr("id");
  $(".dog-shape-text").hide();
  $("."+dog_bodyshape+".dog-shape-text").show();
  // $(".dog-body-type").removeClass("stickynavigation-module__disabled___1GDwt");
  // $(".dog-body-type").find("button").removeAttr("disabled","");
})

// Slider weight

// $(document).ready(function() {
//   var slider = document.getElementById("weight-slider-input-0");
//   var output = document.getElementById("weight");
//   output.innerHTML = slider.value;
//   slider.oninput = function() {
//   output.value = this.value/1000;
//   } 
// })

$(document).ready(function() {
  var slider = $("#weight-slider-input-0");
  var output = $("#weight");

  // Update the input field when the slider is moved
  slider.on('input', function() {
    output.val($(this).val() / 1000);
    // Update cookie whenever the slider changes
    Cookies.set("dogWeight", output.val(), { expires: 7 });
  });

  // Update the slider when the input field value changes
  output.on('input', function() {
    var weightValue = parseFloat($(this).val());
    if (!isNaN(weightValue)) {
      slider.val(weightValue * 1000);
      // Update cookie whenever the input changes
      Cookies.set("dogWeight", $(this).val(), { expires: 7 });
    }
  });
    if (Cookies.get("dogWeight")) {
    output.val(Cookies.get("dogWeight"));
    slider.val(parseFloat(output.val()) * 1000); // Update slider position based on the cookie
    $(".dog-weight").removeClass("stickynavigation-module__disabled___1GDwt");
    $(".dog-weight").find("button").removeAttr("disabled","");
  }
});


$("input[id=weight-slider-input-0]").change(function() {
    $(".dog-weight").removeClass("stickynavigation-module__disabled___1GDwt");
  $(".dog-weight").find("button").removeAttr("disabled","");
})
$("input[id=weight]").change(function() {
    $(".dog-weight").removeClass("stickynavigation-module__disabled___1GDwt");
  $(".dog-weight").find("button").removeAttr("disabled","");
})
$(".dog-activity").click(function() {
  $(".dog-activity").removeClass("activity-module__selected___2esNv");
  $(this).addClass("activity-module__selected___2esNv");
  var dog_activity = $(this).attr("id");
  // $(".dog-lifestyle").removeClass("stickynavigation-module__disabled___1GDwt");
  // $(".dog-lifestyle").find("button").removeAttr("disabled","");
})
$(".pill-allergy input[type=checkbox]").click(function() {
    var dog_allergy = $(this).val();
    if(dog_allergy == "Nothing") {
        $(".pill-module__pill___3tTyo input[type=checkbox].yes-allergy").prop("checked",false);
        $(this).prop("checked",true);
        $(".ingredient-selector").prop("checked", true);
        $("input.variant-selection").prop("checked", true);
    } else {
      $("input[name=dog-0-no-allergies]").prop("checked", false);
    }
  $(".dog-allergy").removeClass("stickynavigation-module__disabled___1GDwt");
  $(".dog-allergy").find("button").removeAttr("disabled","");
    if($("input[name=dog-others]").is(":checked")) {
      $(".pill-allergy.others-allergy").removeClass("hidden");
    } else {
      $(".pill-allergy.others-allergy").addClass("hidden");
    }
})
$("input[name=dog-0-health]").click(function() {
  $(".dog-health-issues").removeClass("stickynavigation-module__disabled___1GDwt");
  $(".dog-health-issues").find("button").removeAttr("disabled","");
  var dog_health = $(this).val();
  if(dog_health == "some") {
    $("#health-issues").removeClass("hidden");
  } else {
    $("#health-issues").addClass("hidden");
  }
})
$(".dog-name").click(function() {
  var dog_name = $("input#dogNameInput-0").val();
  $(".doggy-name").text(dog_name);
})
$(".next").click(function() {
  var active_step = $("section.subscription-step.active").data("step"); 
  $("."+active_step).show();
  $(".progress-text div:not(."+active_step+")").hide();
  $('html, body').animate({
        scrollTop: $("html").offset().top - 20
    }, 'slow');
  var progress_multiplier = $("section.subscription-step.active").data("count");
  $(".progressbar").css("width",progress_multiplier*progress_rate+"%");
  if(active_step == "fifth-step") {
    $(".f-image").addClass("hidden");
    $(".footer-eating-image").removeClass("hidden");
  } else if(active_step == "sixth-step" || active_step == "seventh-step" || active_step == "eighth-step" || active_step == "ninth-step") {
    $(".f-image").addClass("hidden");
    $(".footer-activity-image").removeClass("hidden");
  } else if(active_step == "tenth-step" || active_step == "eleventh-step") {
    $(".f-image").addClass("hidden");
    $(".footer-health-image").removeClass("hidden");
  } else {
    $(".f-image").addClass("hidden");
    $(".footer-basic-image").removeClass("hidden");
  }
  if(active_step == "thirteenth-step" || active_step == "fourteenth-step" || active_step == "fifteenth-step") {
    $(".step-text-container").addClass("hidden");
   // $(".quiz-footer").addClass("hidden");
    $("html").addClass("left");
    $("body").addClass("original-spacing");
    $("body").removeClass("custom-spacing");
  } else {
    $(".step-text-container").removeClass("hidden");
  //  $(".quiz-footer").removeClass("hidden");
    $("html").removeClass("left");
    $("body").removeClass("original-spacing");
    $("body").addClass("custom-spacing");
  }
})
$(".previous").click(function() {
  var active_step = $("section.subscription-step.active").data("step"); 
  $("."+active_step).show();
  $(".progress-text div:not(."+active_step+")").hide();
  $('html, body').animate({
        scrollTop: $("html").offset().top - 20
    }, 'slow');
  var progress_multiplier = $("section.subscription-step.active").data("count");
  $(".progressbar").css("width",progress_multiplier*progress_rate+"%");
  if(active_step == "fifth-step") {
    $(".f-image").addClass("hidden");
    $(".footer-eating-image").removeClass("hidden");
  } else if(active_step == "sixth-step" || active_step == "seventh-step" || active_step == "eighth-step" || active_step == "ninth-step") {
    $(".f-image").addClass("hidden");
    $(".footer-activity-image").removeClass("hidden");
  } else if(active_step == "tenth-step" || active_step == "eleventh-step") {
    $(".f-image").addClass("hidden");
    $(".footer-health-image").removeClass("hidden");
  } else {
    $(".f-image").addClass("hidden");
    $(".footer-basic-image").removeClass("hidden");
  }
  if(active_step == "thirteenth-step" || active_step == "fourteenth-step" || active_step == "fifteenth-step") {
    $(".step-text-container").addClass("hidden");
    $(".quiz-footer").addClass("hidden");
    $("html").addClass("left");
    $("body").addClass("original-spacing");
    $("body").removeClass("custom-spacing");
  } else {
    $(".step-text-container").removeClass("hidden");
    $(".quiz-footer").removeClass("hidden");
    $("html").removeClass("left");
    $("body").removeClass("original-spacing");
    $("body").addClass("custom-spacing");
  }
})
$(document).ready(function() {
var acc = document.getElementsByClassName("faq-question");
var i;
for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    $(this).next().toggleClass("faq-module__answerOpen___3cOdc");
    $(this).find(".faq-module__questionIcon___3yZjs").toggleClass("faq-module__questionIconOpen___1u_lf");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}  
})


// Custom Feature To Get Values Out Of Table 

$(".dog-health-issues").click(function() {
  let servings = 7;
  var dog_movement = $("input[name=dog-activity]:checked").data("value");
  var dog_neutered = $("input[name=dog-0-desexed]:checked").data("value");
  var dog_condition = $("input[name=dog-body]:checked").data("value");
  var dog_development = $("input[name=dog-0-ageStage]:checked").data("multi");
  $("table[data-movement='"+dog_movement+"'][data-neutered='"+dog_neutered+"'][data-condition='"+dog_condition+"']").addClass("active");
  var doggy_years = $("input[name=years]").val();
  var doggy_months = ($("input[name=months]").val()/12).toFixed(2);
  var doggy_rounded_months = Math.ceil(doggy_months);
  var doggy_age = ((+doggy_years) + (+doggy_rounded_months));
  console.log("Age" + doggy_age)
  var doggy_real_age = roundedAge;
  var doggy_real_agee = ((+doggy_years) + (+doggy_months));
  var d_wt = $("input[name=weight]").val();
  var doggy_weight = Math.ceil(d_wt);
  var age_factor;
  if (doggy_real_age < 0.4) {
      age_factor = 0;
  } else if (doggy_real_age >= 0.4 && doggy_real_age < 0.5) {
      age_factor = 6;
  } else if (doggy_real_age >= 0.5 && doggy_real_age < 0.6) {
      age_factor = 5.5;
  } else if (doggy_real_age >= 0.6 && doggy_real_age < 0.7) {
      age_factor = 5;
  } else if (doggy_real_age >= 0.7 && doggy_real_age < 0.8) {
      age_factor = 4.5;
  } else if (doggy_real_age >= 0.8 && doggy_real_age < 0.9) {
      age_factor = 4;
  } else if (doggy_real_age >= 0.9 && doggy_real_age < 1) {
      age_factor = 3.8;
  } else if (doggy_real_age >= 1 && doggy_real_age < 6) {
      age_factor = 3.5;
  } else if (doggy_real_age >= 6 && doggy_real_age < 9) {
      age_factor = 3;
  } else if (doggy_real_age >= 9) {
      age_factor = 2.75;
  }

  
  console.log(dog_neutered, dog_movement, dog_condition, dog_development, doggy_real_age, doggy_real_agee, age_factor);

  var RER = 70 * Math.pow(doggy_weight, 0.75);
  var rerString = document.getElementById('calorieFormula').getAttribute('data-rer');
  var calculateRer = new Function(
    "doggy_weight",
    "return " + rerString
  );
  var rer_formula = calculateRer(doggy_weight);
  console.log("rer", rer_formula);
  
  var MER = Math.ceil(RER * dog_neutered * dog_movement  * dog_condition * dog_development);
  var merString = document.getElementById('calorieFormula').getAttribute('data-mer');
  var calculateMer = new Function(
    "rer_formula", "dog_movement", "dog_condition", "dog_neutered", "dog_development",
    "return " + merString
  );
  var mer_formula = calculateMer(rer_formula, dog_movement, dog_condition, dog_neutered, dog_development);
  console.log("mer", mer_formula);
  
  var grams_needed = mer_formula / 1.3;
  var grams_neededd = Math.ceil(grams_needed / 50) * 50;
  
  var formulaString = document.getElementById('calorieFormula').getAttribute('data-formula');
  var calculateCalories = new Function(
    "doggy_weight", "dog_movement", "dog_condition", "dog_neutered", "age_factor",
    "return " + formulaString
  );
  var calorie_formula = calculateCalories(doggy_weight, dog_movement, dog_condition, dog_neutered, age_factor);
  // var calorie_formulas = 0.07+ ((doggy_weight * dog_movement * dog_condition *(1-0.1 * dog_neutered)* age_factor)/100)
  if (calorie_formula > 0.5) {
        calorie_formula = Math.round(calorie_formula * 10) / 10; 
    } else {
        calorie_formula = Math.ceil(calorie_formula / 0.05) * 0.05; 
    }

  console.log(MER, calorie_formula, grams_neededd)
  
  var dog_age_row = "1"*doggy_months+1;
  if (doggy_age < 1) {
  $('.reference-table table tr > th:contains('+doggy_age+')').parent().addClass("active");
           //$('#ref-table tr:nth-child('+dog_age_row+')').addClass("active");
  } else if (doggy_age == 1) {
    $('.reference-table table tr:nth-child(11)').addClass("active");
  } else if (doggy_age > 1 && doggy_age <= 9) {
   $('.reference-table table tr:nth-child(12)').addClass("active");
  } else if (doggy_age >= 9) {
   $('.reference-table table tr:nth-child(13)').addClass("active");
  }
  
  var dog_weight_col = "2"*doggy_weight+1;
  $('.reference-table table tr:first-child').find("th:nth-child("+dog_weight_col+")").addClass("active");
  var round_calory_beef = ($('.beef-table.active tr.active td:nth-child('+dog_weight_col+')').text()*$(".beef-calories").text()).toFixed();
  var round_calory_chicken = ($('.chicken-table.active tr.active td:nth-child('+dog_weight_col+')').text()*$(".chicken-calories").text()).toFixed();
  //$('.calorie-specification__per-dog__daily-calories').text(round_calory_beef);
  var round_food_weight_beef = ($('.beef-table.active tr.active td:nth-child('+dog_weight_col+')').text()*1000).toFixed();
  var round_food_weight_chicken = ($('.chicken-table.active tr.active td:nth-child('+dog_weight_col+')').text()*1000).toFixed();
  //$('.required-doggy-food-weight').text(round_food_weight_beef);
  if (round_food_weight_beef > 600) {
    var v_select_weight_beef = Math.ceil(round_food_weight_beef/100)*100;
   } else {
    var v_select_weight_beef = Math.ceil(round_food_weight_beef/50)*50;
   }
   if (round_food_weight_chicken > 600) {
    var v_select_weight_chicken = Math.ceil(round_food_weight_chicken/100)*100;
   } else {
     var v_select_weight_chicken = Math.ceil(round_food_weight_chicken/50)*50;
   }
  console.log(doggy_age, doggy_weight, dog_weight_col, dog_movement, dog_neutered, dog_condition);
  
  // Know the allergies of dog
  var doggy_allergy = $(".pill-allergy input[type=checkbox]:checked").map( function() {
    return this.value;
  }).get().join(",");
  
  if(doggy_allergy.includes("chicken")) {
    servings = "1";
    $(".item-individual[data-type=chicken]").addClass("disabled");
    $(".item-individual").not("[data-type=chicken]").find(".item-atc-button").trigger("click");
    $(".item-individual").not("[data-type=chicken]").find(".p-weight").text(v_select_weight_beef+ "g");
    $(".item-individual").not("[data-type=chicken]").find(".serving").text(servings);
    $(".item-individual").not("[data-type=chicken]").find(".s-text").text(" Servings");
    $(".item-individual").not("[data-type=chicken]").find("select.doggy-food-w-variant").addClass("active");
    $(".item-individual").not("[data-type=chicken]").find("input[name=selling_plan].subscribe").addClass("active");
    $(".item-individual").not("[data-type=chicken]").find(".s-dropdown option.serving-size-"+servings).attr("selected","selected");
    $(".item-individual[data-type=chicken]").find(".selections-items").hide();
    $(".item-individual").not("[data-type=chicken]").find(".selections-items").show();
    $('.required-doggy-food-weight').text(round_food_weight_beef);
    $('.calorie-specification__per-dog__daily-calories').text(round_calory_beef);
  } else if(doggy_allergy.includes("beef")) {
    servings = "1";
    $(".item-individual[data-type=beef]").addClass("disabled");
    $(".item-individual").not("[data-type=beef]").find(".item-atc-button").trigger("click");
    $(".item-individual").not("[data-type=beef]").find(".p-weight").text(v_select_weight_beef+ "g");
    $(".item-individual").not("[data-type=beef]").find(".serving").text(servings);
    $(".item-individual").not("[data-type=beef]").find(".s-text").text(" Servings");
    $(".item-individual").not("[data-type=beef]").find("select.doggy-food-w-variant").addClass("active");
    $(".item-individual").not("[data-type=beef]").find("input[name=selling_plan].subscribe").addClass("active");
    $(".item-individual").not("[data-type=beef]").find(".s-dropdown option.serving-size-"+servings).attr("selected","selected");
    $(".item-individual[data-type=beef]").find(".selections-items").hide();
    $(".item-individual").not("[data-type=beef]").find(".selections-items").show();
    $('.required-doggy-food-weight').text(round_food_weight_chicken);
    $('.calorie-specification__per-dog__daily-calories').text(round_calory_chicken);
  } else if(doggy_allergy.includes("pork")) {
    servings = "1";
    $(".item-individual[data-type=pork]").addClass("disabled");
    $(".item-individual").not("[data-type=pork]").find(".item-atc-button").trigger("click");
    $(".item-individual").not("[data-type=pork]").find(".p-weight").text(v_select_weight_beef+ "g");
    $(".item-individual").not("[data-type=pork]").find(".serving").text(servings);
    $(".item-individual").not("[data-type=pork]").find(".s-text").text(" Servings");
    $(".item-individual").not("[data-type=pork]").find("select.doggy-food-w-variant").addClass("active");
    $(".item-individual").not("[data-type=pork]").find("input[name=selling_plan].subscribe").addClass("active");
    $(".item-individual").not("[data-type=pork]").find(".s-dropdown option.serving-size-"+servings).attr("selected","selected");
    $(".item-individual[data-type=pork]").find(".selections-items").hide();
    $(".item-individual").not("[data-type=pork]").find(".selections-items").show();
    $('.required-doggy-food-weight').text(round_food_weight_chicken);
    $('.calorie-specification__per-dog__daily-calories').text(round_calory_chicken);
  } else if(doggy_allergy.includes("turkey")) {
    servings = "1";
    $(".item-individual[data-type=turkey]").addClass("disabled");
    $(".item-individual").not("[data-type=turkey]").find(".item-atc-button").trigger("click");
    $(".item-individual").not("[data-type=turkey]").find(".p-weight").text(v_select_weight_beef+ "g");
    $(".item-individual").not("[data-type=turkey]").find(".serving").text(servings);
    $(".item-individual").not("[data-type=turkey]").find(".s-text").text(" Servings");
    $(".item-individual").not("[data-type=turkey]").find("select.doggy-food-w-variant").addClass("active");
    $(".item-individual").not("[data-type=turkey]").find("input[name=selling_plan].subscribe").addClass("active");
    $(".item-individual").not("[data-type=turkey]").find(".s-dropdown option.serving-size-"+servings).attr("selected","selected");
    $(".item-individual[data-type=turkey]").find(".selections-items").hide();
    $(".item-individual").not("[data-type=turkey]").find(".selections-items").show();
    $('.required-doggy-food-weight').text(round_food_weight_chicken);
    $('.calorie-specification__per-dog__daily-calories').text(round_calory_chicken);
  } else {
    servings = "1";
    $(".item-individual").removeClass("disabled");
    $(".item-individual .item-atc-button").trigger("click");
    $(".item-individual .serving").text(servings);
    $(".item-individual .s-text").text(" Servings");
    $(".item-individual[data-type=beef] .p-weight").text(v_select_weight_beef+ "g");
    $(".item-individual[data-type=chicken] .p-weight").text(v_select_weight_chicken+ "g");
    $(".item-individual select.doggy-food-w-variant").addClass("active");
    $(".item-individual input[name=selling_plan].subscribe").addClass("active");
    $('.required-doggy-food-weight').text(round_food_weight_beef);
    $('.grams-needed').text(grams_neededd);
    $('.gramos-value').text(grams_neededd +"g");
    $('.calorie-specification__per-dog__daily-calories').text(round_calory_beef);
    $(".item-individual").find(".s-dropdown option.serving-size-"+servings).attr("selected","selected");
    $(".item-individual").find(".selections-items").show();
  }

    console.log(v_select_weight_chicken, v_select_weight_beef);
    $(".item-individual[data-type=chicken]").find(".doggy-food-w-variant option.v-"+grams_neededd+"g").attr("selected","selected");
    $(".item-individual[data-type=beef]").find(".doggy-food-w-variant option.v-"+grams_neededd+"g").attr("selected","selected");
    $(".item-individual[data-type=pork]").find(".doggy-food-w-variant option.v-"+grams_neededd+"g").attr("selected","selected");
    $(".item-individual[data-type=turkey]").find(".doggy-food-w-variant option.v-"+grams_neededd+"g").attr("selected","selected");
    updatePriceDisplay();
    calculateBags();
    calculateRecommendedPrice();
    updateFoodIngredients();
    DistributeVariantsQuantity();
    $(".item-atc-button").addClass("cart");

  
  // Set the cookies 
  
  var dog_name = $("input#dogNameInput-0").val();
  Cookies.set("dogName", dog_name, { expires: 5 });
  
  var dog_gender_value = $('input[name=dog-0-gender]:checked').val();
  Cookies.set("dogGender", dog_gender_value, { expires: 5 });
  
  var dog_desexed_value = $('input[name=dog-0-desexed]:checked').val();
  Cookies.set("dogNeutered", dog_desexed_value, { expires: 5 });
  
  var dog_ageStage = $("input[name=dog-0-ageStage]:checked").val();
  Cookies.set("dogAgeStage", dog_ageStage, { expires: 5 });
  
  var dogDOB = $("input.birth-date").val();
  Cookies.set("dogDOB", dogDOB, { expires: 5 });
  
  var dog_breed = $("input.breed-input").val();
  Cookies.set("dogBreed", dog_breed, { expires: 5 });
  
  var dog_food = $("input[name=dog-0-food]:checked").map(function() { 
    return this.value;
  }).get();
  Cookies.set("dogFood", JSON.stringify(dog_food), { expires: 5 });
  
  var dog_eatingHabit = $("input[name=dog-eating-habit]:checked").val();
  Cookies.set("dogEatingHabit", dog_eatingHabit, { expires: 5 });
  
  var dog_bodyShape = $("input[name=dog-body]:checked").val();
  Cookies.set("dogBodyShape", dog_bodyShape, { expires: 5 });
  
  var dog_activity = $("input[name=dog-activity]:checked").val();
  Cookies.set("dogActivity", dog_activity, { expires: 5 });
  
  var dog_weight = $("input#weight").val();
  Cookies.set("dogWeight", dog_weight, { expires: 5 });
  
  var dog_health = $("input[name=dog-0-health]:checked").val();
  Cookies.set("dogHealth", dog_health, { expires: 5 });
  
  var dog_health_issues = $("input#health-issues").val();
  Cookies.set("dogHealthIssues", dog_health_issues, { expires: 5 });

  var dog_no_allergy = $("input[name=dog-0-no-allergies]:checked").val();
  Cookies.set("dogNoAllergy", dog_no_allergy, { expires: 5 });

  var dog_allergies = $('input.yes-allergy:checked').map(function() {
    return this.value;
  }).get();
  Cookies.set("dogAllergy", JSON.stringify(dog_allergies), { expires: 5 });
  
});

$(".clear-table").click(function() {
  $('.reference-table table tr').removeClass("active");
  $('.reference-table table th').removeClass("active");
  $(".item-individual").removeClass("disabled");
  $(".item-individual").removeClass("active");
  $(".item-individual .item-atc-button").removeClass("active");
  $(".item-individual .serving").text("");
  $(".item-individual .s-text").text("");
  $(".item-individual .p-weight").text("");
  $(".doggy-food-w-variant option").removeAttr("selected");
  $(".item-individual select.doggy-food-w-variant").removeClass("active");
  $(".item-individual input[name=selling_plan].subscribe").removeClass("active");
  $(".s-dropdown").removeAttr("selected");
  $(".item-individual").find(".selections-items").show();
})
$(".item-atc-button").click(function(){
  $(this).toggleClass("active");
  $(this).parent().toggleClass("active");
  $(this).parent().find(".doggy-food-w-variant").toggleClass("active");
  $(this).parent().find("input[name=selling_plan].subscribe").toggleClass("active");
})

/*
$(".item-atc-button.cart").click(function() {
  var variant_id = $(this).parent().find("select.doggy-food-w-variant").val();
  var selling_plan = $(this).parent().find("input[name=selling_plan]").val();
  console.log(variant_id, selling_plan);
   data = {
      "id": variant_id,
      "quantity": 1,
      "selling_plan": selling_plan
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        window.location.href = '/cart'; 
      }
    });
})  */


//Searchable Breed Option

var wordss = $(".all_breeds_json").data("all-breeds");
var array = wordss[0].split(',');
array_result = array.map(i => '' + i + '');
const words =array_result;
const containerEl = document.querySelector('div[role=combobox]')
const formEl = document.querySelector('#downshift-3-input')
const dropEl = document.querySelector('.breed-selector')

const formHandler = (e) => {
    const userInput = e.target.value.toLowerCase()

    if(userInput.length === 0) {
        dropEl.style.height = 0
        return dropEl.innerHTML = ''              
    }

    const filteredWords = words.filter(word => word.toLowerCase().includes(userInput)).sort().splice(0, 5)
    
    dropEl.innerHTML = ''
    filteredWords.forEach(item => {
        const listEl = document.createElement('li')
        listEl.setAttribute('role', 'option');
        listEl.textContent = item
        if(item === userInput) {
            listEl.classList.add('match')
        }
        dropEl.appendChild(listEl)
    })

    if(dropEl.children[0] === undefined) {
        return dropEl.style.height = 0
    }

    let totalChildrenHeight = dropEl.children[0].offsetHeight * filteredWords.length
    dropEl.style.height = totalChildrenHeight + 'px'

}

formEl.addEventListener('input', formHandler);

$("#variant-switcher").change(function() {
    var weight = $(this).find("option:selected").text();
    $(this).parent().parent().parent().find(".p-weight").text(weight);
})
$(".s-dropdown").change(function() {
    var serving = $(this).val();
    $(this).parent().parent().parent().find(".serving").text(serving);
})

// $(".cart-button").click(function() {
//   $(".modal").show();
  
//   var variant_ids = $(".item-atc-button").parent().find("select.doggy-food-w-variant.active").map(function() {
//     return this.value;
//   }).get();
  
//   var selling_plans = $(".item-atc-button").parent().find("input[name=selling_plan].active").map(function() {
//     return this.value;
//   }).get();
  
//   var order_quantity = $(".item-individual.active").find(".serving").map(function() {
//     return $(this).text();
//   }).get();
  
//   console.log(variant_ids, selling_plans, order_quantity);
  
//   Shopify.queue = [];
//   var bundleId = 'bundle_' + new Date().getTime(); // Unique bundle identifier

//   for (var i = 0; i < variant_ids.length; i++) {
//     Shopify.queue.push({
//       variantId: variant_ids[i],
//       sellingId: selling_plans[i],
//       quantityId: order_quantity[i]
//     });
//   }
  
//   // Function to add items to the cart
//   Shopify.moveAlong = function() {
//     if (Shopify.queue.length) {
//       var request = Shopify.queue.shift();
//       var data = {
//         "id": request.variantId,
//         "quantity": request.quantityId,
//         "selling_plan": request.sellingId
//       };
//       $.ajax({
//         type: 'POST',
//         url: '/cart/add.js',
//         dataType: 'json',
//         data: data,
//         success: function(res) {
//           Shopify.moveAlong();
//         },
//         error: function() {
//           if (Shopify.queue.length) {
//             Shopify.moveAlong();
//           }
//         }
//       });
//     } else {
//       window.location.href = '/checkout';
//     }
//   };

//   // Clear the cart first
//   $.ajax({
//     type: 'POST',
//     url: '/cart/clear.js',
//     dataType: 'json',
//     success: function() {
//       Shopify.moveAlong(); // Start adding items after the cart is cleared
//     }
//   });
// });






// Function to update cart quantity via AJAX
function updateCartQuantity(productId, quantity, quantityDisplayElement) {
    $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: {
            id: productId,
            quantity: quantity,
        },
        dataType: "json",
        success: function (response) {
            quantityDisplayElement.text(quantity);
            console.log("Cart item quantity updated:", response);
            // Optionally, you might want to trigger a cart update event here
            // e.g., $(document).trigger('cartUpdated');
        },
        error: function (error) {
            alert("Failed to update cart quantity. Please try again.");
            console.error("Error updating cart quantity:", error);
        },
    });
}

// --- Logic for Original Structure (.add-to-cart, .quantity-controls) ---


  // Your existing Add to Cart button click handler (for .add-to-cart class)
  // Keep this if you still have elements with the .add-to-cart class.
  // If you are transitioning entirely to .action001, you might eventually remove this.
 
// =========================================================================
// LOCAL STORAGE FUNCTIONS (REPLACES ALL CART AJAX)
// Key for local storage
const LOCAL_STORAGE_KEY = 'collectedProducts';

/**
 * Helper function to manage product data in local storage.
 * @param {string} productId - The ID of the product.
 * @param {number} newQuantity - The quantity to set (0 to remove).
 * @returns {number} The actual quantity saved in local storage, or 0 if removed.
 */
function updateProductLocalStorage(productId, newQuantity) {
    // 1. Retrieve data
    let collectedItems = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || [];
    
    // 2. Find product index
    const existingIndex = collectedItems.findIndex(item => item.id === productId);

    if (newQuantity > 0) {
        // --- Add or Update ---
        if (existingIndex > -1) {
            // Update existing product quantity
            collectedItems[existingIndex].quantity = newQuantity;
        } else {
            // Add new product
            collectedItems.push({ id: productId, quantity: newQuantity });
        }
        console.log(`Product ${productId} set to quantity: ${newQuantity} in localStorage.`);
    } else {
        // --- Remove (newQuantity is 0) ---
        if (existingIndex > -1) {
            collectedItems.splice(existingIndex, 1); // Remove the item
            console.log(`Product ${productId} removed from localStorage.`);
        }
        newQuantity = 0; // Ensure return value is 0
    }

    // 3. Save data
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(collectedItems));
    
    return newQuantity;
}

// =========================================================================
// 1. INITIAL ADD/SHOW COUNTER (.add-to-cart click handler)
// =========================================================================

$(".add-to-cart").click(function() {
    let button = $(this);
    const productId = button.data("product-id");

    // 1. Update/Add to Local Storage (Always adds 1 initially)
    const finalQuantity = updateProductLocalStorage(productId, 1);
    
    // 2. Update the UI
    if (finalQuantity > 0) {
        button.hide();
        const $controls = button.siblings(".quantity-controls");
        $controls.show();
        $controls.find(".current-quantity").text(finalQuantity);
    }
});

// =========================================================================
// 2. INCREASE QUANTITY (.quantity-increase click handler)
// =========================================================================

$(".quantity-increase").click(function () {
    let $increaseBtn = $(this);
    let $parentActions = $increaseBtn.parents(".product-actions");
    
    // Find productId from the associated .add-to-cart button
    let productId = $parentActions.find(".add-to-cart").data("product-id");
    
    const $quantitySpan = $increaseBtn.siblings(".current-quantity");
    const currentQuantity = parseInt($quantitySpan.text());
    const newQuantity = currentQuantity + 1;
    
    // Update Local Storage
    updateProductLocalStorage(productId, newQuantity);

    // Update the UI immediately
    $quantitySpan.text(newQuantity);
});

// =========================================================================
// 3. DECREASE QUANTITY (.quantity-decrease click handler)
// =========================================================================

$(".quantity-decrease").click(function () {
    let $decreaseBtn = $(this);
    let $parentActions = $decreaseBtn.parents(".product-actions");
    
    // Find productId from the associated .add-to-cart button
    let productId = $parentActions.find(".add-to-cart").data("product-id");

    const $quantitySpan = $decreaseBtn.siblings(".current-quantity");
    const currentQuantity = parseInt($quantitySpan.text());
    
    if (currentQuantity > 1) {
        // Decrease quantity (Quantity > 1)
        const newQuantity = currentQuantity - 1;
        
        // Update Local Storage
        updateProductLocalStorage(productId, newQuantity);

        // Update the UI immediately
        $quantitySpan.text(newQuantity);
    } 
    else if (currentQuantity === 1) {
        // Decrease quantity to 0 (Remove from storage and revert UI)
        const newQuantity = 0;
        
        // Update Local Storage (this will remove the item)
        updateProductLocalStorage(productId, newQuantity);
        
        // Revert UI: Hide controls, show original button
        $parentActions.find(".quantity-controls").hide();
        $parentActions.find(".add-to-cart").show();
        
        $quantitySpan.text(0); // Optional: Set to 0 briefly or just let it hide
    } 
    else {
        alert("Quantity is already 0.");
    }
});
// This code will execute as soon as the page loads (or when this script is reached)




// 1. Check if the key 'collectedProducts' exists (optional but good practice)
if (localStorage.getItem('collectedProducts') !== null) {
    // 2. Remove the 'collectedProducts' item from local storage
    localStorage.removeItem('collectedProducts');
    console.log('localStorage key "collectedProducts" has been removed on page load.');
} else {
    console.log('localStorage key "collectedProducts" was not found, no removal needed.');
}


// --- Logic for New Structure (.action001, .btn001, .countwrap001) ---

// Show counter and hide add button for new structure
// This now acts as the "add to cart" for the new structure


// Any other page loading logic follows...
  // =========================================================================
  // NEW/MODIFIED FUNCTIONS FOR THE .action001 COUNTER
  // These replace the vanilla JS functions from the previous response.
  // =========================================================================

 // Function to show the counter (triggered by onclick="showCounter(this)" on btn001)
window.showCounter = function (btnElement) {
  let $btn = $(btnElement); // Convert to jQuery object
  let $actionBox = $btn.closest('.action001');
  const productId = $actionBox.data("product-id");
  const $countSpan = $actionBox.find('.count001');

  // 🔥 REPLACE AJAX WITH LOCAL STORAGE
  const finalQuantity = updateProductLocalStorage(productId, 1);

  if (finalQuantity > 0) {
    $actionBox.addClass('show001'); // Show quantity controls
    $countSpan.text(finalQuantity); // Set to 1 (or whatever was saved)
    console.log("Product added to localStorage via action001:", productId);
  } else {
    console.warn("Failed to add product to localStorage:", productId);
  }
};
 // Function to increment quantity (triggered by onclick="increment(this)" on btnplus001)
window.increment = function (btnElement) {
  let $btn = $(btnElement);
  let $actionBox = $btn.closest('.action001');
  const productId = $actionBox.data("product-id");
  const $countSpan = $actionBox.find('.count001');
  const currentQuantity = parseInt($countSpan.text()) || 0;
  const newQuantity = currentQuantity + 1;

  // Update localStorage
  updateProductLocalStorage(productId, newQuantity);

  // Update UI
  $countSpan.text(newQuantity);
};

// Function to decrement quantity (triggered by onclick="decrement(this)" on btnminus001)
window.decrement = function (btnElement) {
  let $btn = $(btnElement);
  let $actionBox = $btn.closest('.action001');
  const productId = $actionBox.data("product-id");
  const $countSpan = $actionBox.find('.count001');
  const currentQuantity = parseInt($countSpan.text()) || 0;

  if (currentQuantity > 1) {
    const newQuantity = currentQuantity - 1;
    updateProductLocalStorage(productId, newQuantity);
    $countSpan.text(newQuantity);
  } else if (currentQuantity === 1) {
    // Remove from cart (set quantity to 0)
    updateProductLocalStorage(productId, 0);

    // Hide counter, show initial button
    $actionBox.removeClass('show001');
    $actionBox.find('.btn001').show(); // assumes your "+" button has class .btn001
    // Optional: reset count to 1 for next time
    $countSpan.text(1);
  }
};

  // --- Handler for the "Confirmar" button (Clears the Cart) ---
  // IMPORTANT: Ensure this selector targets your "Confirmar" button correctly.
  // If "okomopoko" is not the correct class, change it to the right one (e.g., ".button-module__buttonText___1kKa8")
  $(".okomopoko").click(function() {
    console.log("Confirmar (okomopoko) Button Click: Initiating cart clear...");

    jQuery.ajax({
      type: 'POST',
      url: '/cart/clear.js',
      dataType: 'json',
      success: function() {
        console.log('Confirmar (okomopoko) Button Click: Cart clear request sent successfully.');
        // No loading screen or popup as requested
      },
      error: function(jqXHR, textStatus, errorThrown) {
        console.error('Confirmar (okomopoko) Button Click: Failed to clear cart:', textStatus, errorThrown);
        console.error('Confirmar (okomopoko) Button Click: Response:', jqXHR.responseText);
        // No loading screen or popup as requested, just console error
      }
    });
  });

  // --- Main cart submission logic (triggered by .cart-button) ---
  $(".cart-button").click(function() {
    $(".modal").show(); // Show loading/modal as this button is intended to proceed
    let items = []; // Initialize items array for all products

    // 1. Gather main dog food products (from input.variant-selection:checked)
    console.log("Cart Button Click: Gathering main products...");
    $('input.variant-selection:checked').each(function() {
      let quantity = parseInt($(this).data("quantity"));
      let variantId = $(this).val();
      // Using .data("selling_plan_id") as a primary fallback, then .data("selling_id")
      let selling_plan_id = $(this).data("selling_plan_id") || $(this).data("selling_id");
      var line_item_properties = {
        "Resumen": quantity + " paquetes de 500gr",
      };
      var payment_mode = $("input[name=payment-selectorr]:checked").val();
      var frequency = $(".frequency-option").text();
      if (payment_mode === "manual") {
        line_item_properties["Frecuencia"] = frequency;
      }

      if (quantity > 0) {
        items.push({
          id: variantId,
          quantity: quantity,
          selling_plan: selling_plan_id,
          properties: line_item_properties
        });
        console.log(`Cart Button Click: Added main product - ID: ${variantId}, Qty: ${quantity}`);
      }
    });

    // 2. Gather addon products (ONLY from their VISIBLE quantity controls)
    console.log("Cart Button Click: Gathering addon products...");
    console.log("Cart Button Click: Total .quantity-controls in DOM:", $(".addon-container .quantity-controls").length);
    console.log("Cart Button Click: Visible .quantity-controls found for adding:", $(".addon-container .quantity-controls:visible").length);

    $(".addon-container .quantity-controls:visible").each(function() {
      const currentQuantity = parseInt($(this).find(".current-quantity").text());
      const productId = $(this).siblings(".add-to-cart").data("product-id");

      console.log(`Cart Button Click: Processing visible addon - ID: ${productId}, Current Qty: ${currentQuantity}`);

      if (currentQuantity > 0 && productId) {
        items.push({
          id: productId,
          quantity: currentQuantity,
          properties: {
            "Addon Product": "Yes"
          }
        });
        console.log(`Cart Button Click: Added addon product - ID: ${productId}, Qty: ${currentQuantity}`);
      } else {
        console.log(`Cart Button Click: Skipping addon - ID: ${productId}, Qty: ${currentQuantity} (not > 0 or productId missing)`);
      }
    });
    console.log("Cart Button Click: Final items array to add:", items);

    // 3. Gather order note details from cookies
    var dog_name = Cookies.get("dogName");
    var dog_gender = Cookies.get("dogGender");
    var dog_neutered = Cookies.get("dogNeutered");
    var dog_category = Cookies.get("dogAgeStage");
    var dog_breed = Cookies.get("dogBreed");
    var dog_food_type = Cookies.get("dogFood");
    var dog_eating_type = Cookies.get("dogEatingHabit");
    var dog_shape = Cookies.get("dogBodyShape");
    var dog_activity = Cookies.get("dogActivity");
    var dog_weight = Cookies.get("dogWeight");
    var dog_allergies = Cookies.get("dogAllergy");

    var orderNote = "Dog's Name: " + dog_name + "; Dog's Gender: " + dog_gender + "; Dog Neutered: " + dog_neutered + "; Dog Category: " + dog_category + "; Dog Breed: " + dog_breed + "; Dog Food Type: " + dog_food_type + "; Dog Eating Type: " + dog_eating_type + "; Dog Shape: " + dog_shape + "; Dog Activity: " + dog_activity + "; Dog Weight: " + dog_weight + "; Dog Allergies: " + dog_allergies;
    
    
    
// >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
// ADD: Extra pet info from localStorage (your 8 fields)
// <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
var extraNoteLines = [];
var extraFields = [
  { key: 'Extra Pet Type', label: 'Extra Pet Type' },
  { key: 'Extra Pet Pet Name', label: 'Extra Pet Name' },
  { key: 'Extra Pet Pet Breed', label: 'Extra Pet Breed' },
  { key: 'Extra Pet Pet Neutered', label: 'Extra Pet Neutered' },
  { key: 'Extra Pet Pet Stage', label: 'Extra Pet Stage' },
  { key: 'Extra Pet Pet Weight', label: 'Extra Pet Weight' },
  { key: 'Extra Pet Pet Activity', label: 'Extra Pet Activity' },
  { key: 'Extra Pet Pet Allergies', label: 'Extra Pet Allergies' }
];

extraFields.forEach(function(field) {
  var value = localStorage.getItem(field.key);
  if (value && value.trim()) {
    extraNoteLines.push(field.label + ": " + value.trim());
  }
});

if (extraNoteLines.length > 0) {
  orderNote += " | EXTRA PET INFO: " + extraNoteLines.join("; ");
}
// <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<

    
    
    
    console.log("Cart Button Click: Order Note prepared.");





    
    // Determine checkout URL
    let checkoutUrl = $("form#cart").attr('action');
    checkoutUrl = checkoutUrl.replace('/cart/', '/checkout/');
    console.log("Cart Button Click: Checkout URL:", checkoutUrl);

    // Ensure there are items to add
    if (items.length === 0) {
      $(".modal").hide();
      alert("Please select products before proceeding to checkout."); // Still showing alert for user action here
      console.warn("Cart Button Click: No items to add to cart.");
      return; // Exit the function if no items
    }

    let data = {
      items: items,
      note: orderNote
    };

    // Add all gathered items to the cart (assuming it's already cleared by "Confirmar")
    console.log("Cart Button Click: Sending add.js request with data:", data);
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: JSON.stringify(data),
      contentType: 'application/json',
      dataType: 'json',
      success: function(response) {
        console.log('Products successfully added to cart:', response);
        window.location.href = checkoutUrl + 'discount=bienvenido,SHIPFREE';
      },
      error: function(jqXHR, textStatus, errorThrown) {
        $(".modal").hide(); // Hide loading modal on error
        alert('Failed to add products to cart. Please try again.'); // Still showing alert for add error
        console.error('Failed to add products to cart:', textStatus, errorThrown);
        console.error('Response:', jqXHR.responseText);
      }
    });
  });













$(".details").click(function(){ 
  $(this).next(".p-detail").css("z-index", "100");
  $("body").css("overflow", "hidden");
})
$(".close-popup").click(function() {
  $(".p-detail").css("z-index", "-1");
  $("body").css("overflow", "auto");
})

$(document).ready(function() {
    // When Auto Payment is checked
    $("#sellingg_plan_subscribe").change(function() {
        if ($(this).is(":checked")) {
            $(".selling-name .subscribe").prop("checked", true).trigger("change");
            $(".selling-name .subscribe").addClass("active");
            $(".selling-name .onetime").removeClass("active");
        }
    });

    // When Manual Payment is checked
    $("#sellingg_plan_onetime").change(function() {
        if ($(this).is(":checked")) {
            $(".selling-name .onetime").prop("checked", true).trigger("change");
            $(".selling-name .onetime").addClass("active");
            $(".selling-name .subscribe").removeClass("active");
        }
    });

    // Optional: To synchronize the state on page load
    if ($("#sellingg_plan_subscribe").is(":checked")) {
        $(".selling-name .subscribe").prop("checked", true);
        $(".selling-name .subscribe").addClass("active");
        $(".selling-name .onetime").removeClass("active");
    }

    if ($("#sellingg_plan_onetime").is(":checked")) {
        $(".selling-name .onetime").prop("checked", true);
        $(".selling-name .onetime").addClass("active");
        $(".selling-name .subscribe").removeClass("active");
    }
});

function updateFoodIngredients() {
  var food_items = $(".recipe-item").find("input.ingredient-selector:checked").map(function() {
    return this.value;
  }).get().join(", ");
  $(".food-ingredients").text(food_items);

  const allergyCheckboxess = $('.ingredient-selector');
  const ingredientVariantCheckboxes = $('input.variant-selection');
  const selectedAllergiess = allergyCheckboxess.filter(':checked').map(function() {
      return $(this).val().toLowerCase();
  }).get();
  ingredientVariantCheckboxes.each(function() {
      const ingredientVariants = $(this).data("flavor").toLowerCase();
      if (selectedAllergiess.includes(ingredientVariants)) {
          $(this).prop('checked', true);
      } else {
          $(this).prop('checked', false);
      }
  });
}


function updatePriceDisplay() {
    var totalPrice = $(".doggy-food-w-variant.active option:selected").map(function() {
      return $(this).data("price");
    }).get().reduce(function(accumulator, currentValue) {
      return accumulator + currentValue;
    }, 0);
  console.log(totalPrice)
  var t_price = (totalPrice / 3000).toFixed(2);
  var f_price = (totalPrice / 6000).toFixed(2);

    $(".total-price").text("$" + t_price + "/day");
    $(".final-price").text("$" + f_price + "/day");
  }

  $(document).on('change', '.doggy-food-w-variant.active', function() {
    updatePriceDisplay();
  });


$(document).ready(function() {
var inputt = document.querySelector("input#petParentMobile");
var iti = intlTelInput(inputt, {
    initialCountry: "ve",
    separateDialCode: true,
    formatAsYouType: false,
    strictMode: true,
    utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/22.0.0/js/utils.js',
  });
  
var countryCode = '+' + iti.getSelectedCountryData().dialCode;
inputt.value = countryCode;
  
  inputt.addEventListener('input', function() {
    var number = iti.getNumber(intlTelInputUtils.numberFormat.E164);
    if(iti.isValidNumber()) {
      console.log('Valid number: ' + number);
      Cookies.set("dogOwnerMobile", number, { expires: 5 });
    } else {
      console.log('Invalid number');
    }
  });

// To dynamically set the full phone number with the country code as the user types or changes country
inputt.addEventListener('countrychange', function() {
    var dialCode = "+" + iti.getSelectedCountryData().dialCode;
    inputt.value = dialCode;
    Cookies.set('selectedDialCode', dialCode, { expires: 5 });
});

    var savedDialCode = Cookies.get('selectedDialCode');
    console.log("Saved code:" + savedDialCode)
    const countryData = intlTelInput.getCountryData();
    if (savedDialCode) {
        var matchingCountry = countryData.find(country => '+' + country.dialCode === savedDialCode);
        if (matchingCountry) {
            iti.setCountry(matchingCountry.iso2);
        }
    } else {
        var countryCode = '+' + iti.getSelectedCountryData().dialCode;
        console.log(countryCode);
        inputt.value = countryCode;
    }
     var OwnerMobile = Cookies.get("dogOwnerMobile");
     if (OwnerMobile) {
       $("#petParentMobile").val(Cookies.get("dogOwnerMobile"));
     }

  function updateButtonState() {
    var name = $('#petParentFullName').val();
    var email = $('#petParentEmail').val();
    var phone = iti.getNumber();
    var parent_id = $('#petParentId').val();
  
    // Check if all fields are filled and the phone number is valid
    if (name && email && phone && parent_id && iti.isValidNumber()) {
      $(".dog-account").removeClass("stickynavigation-module__disabled___1GDwt");
      $(".dog-account").find("button").removeAttr("disabled");
    } else {
      $(".dog-account").addClass("stickynavigation-module__disabled___1GDwt");
      $(".dog-account").find("button").attr("disabled","");
    }
  
    // Update cookies
    Cookies.set("dogOwnerName", name, { expires: 5 });
    Cookies.set("dogOwnerEmail", email, { expires: 5 });
    Cookies.set("dogOwnerId", parent_id, { expires: 5 });
}

$('#petParentFullName, #petParentEmail, #petParentMobile, #petParentId').on('input', updateButtonState);

inputt.addEventListener('countrychange', updateButtonState);

$('#petParentId').on('input', function() {
  $('#petParentPassword').val($(this).val());
});

$('#prefixDropdown').change(function() {
  Cookies.set("selectedPrefix", $(this).val(), { expires: 5 });
});

var selectedPrefix = Cookies.get("selectedPrefix");
if (selectedPrefix) {
 $("#prefixDropdown").val(Cookies.get("selectedPrefix"));
}

});

// jQuery(function() {
//   jQuery('#create_customer').submit(function(event) {
//     event.preventDefault();
//     var data = jQuery(this).serialize();
//     var name = $('#petParentFullName').val();
//     var lastName = "";
//     var password;
//     var email = $('#petParentEmail').val();
//     var dogName = $('#dogNameInput-0').val();
//     var dogBreed = $('input.breed-input').val();
//     var dogAge = $('input.birth-date').val();
//     var dogNeutered = $('input[name=dog-0-desexed]:checked').val();
//     var dogWeight = $("input[name=weight]").val();
//     var dogShape = $('input[name=dog-body]:checked').val();
//     var dogActivity = $('input[name=dog-activity]:checked').val();
//     var escapedData = {
//       firstName: escape(name),
//       lastName: escape(lastName),
//       password: escape(password),
//       email: escape(email),
//       dogName: escape(dogName),
//       dogBreed: escape(dogBreed),
//       dogAge: escape(dogAge),
//       dogNeutered: escape(dogNeutered),
//       dogWeight: escape(dogWeight),
//       dogShape: escape(dogShape),
//       dogActivity: escape(dogActivity),
//   }
//   var data = 'form_type=create_customer&utf8=%E2%9C%93&customer%5Bfirst_name%5D=';
//   data += escapedData.firstName;
//   data += '&customer%5Blast_name%5D=';
//   data += escapedData.lastName;
//   data += '&customer%5Bemail%5D=';
//   data += escapedData.email;
//   data += '&customer%5Bpassword%5D=';
//   data += escapedData.password;
//   data += '&customer%5Bnote%5D=' + JSON.stringify({
//         dogName: escapedData.dogName,
//         dogBreed: escapedData.dogBreed,
//         dogAge: escapedData.dogAge,
//         dogNeutered: escapedData.dogNeutered,
//         dogWeight: escapedData.dogWeight,
//         dogShape: escapedData.dogShape,
//         dogActivity: escapedData.dogActivity,
//       });
    
//   jQuery.post('/account', data)
//   .done(function(response){
//     var logErrors = jQuery(response).find('.errors').text();
//     if (logErrors != '' && logErrors != 'undefined'){
//       console.log(logErrors);
//     }
//     else{
//       console.log('success!');
//     }
//   }).fail(function(){console.log('error could not submit');});
//   return false;
//   });
// });

jQuery('#create_customer').submit(function(event) {
    event.preventDefault();
});

$(document).ready(function() {

$(document).on('cf:customer_saved', function(e) {
  e.preventDefault();
  window.stop();
  console.log('Customer data saved without reloading the page.');
  return false;
});
  
$('#saveCustomer').click(function(e) {
  e.preventDefault();
  window.stop();
var name = $('#petParentFullName').val();
var email = $('#petParentEmail').val();
var phone = $('#petParentMobile').val();
var password = $('#petParentPassword').val();
var dog_name = $('#dogNameInput-0').val();
var dog_breed = $('input.breed-input').val();
// var dog_dob = $('input.birth-date').val();
var dog_neutered = $('input[name=dog-0-desexed]:checked').val();
var dog_weight = $("input[name=weight]").val();
var dog_shape = $('input[name=dog-body]:checked').val();
var dog_activity = $('input[name=dog-activity]:checked').val();
var prefix = $('#prefixDropdown').val();
var parent_id = $('#petParentId').val();
  
var customerSaveOptions = {
  login: true,
  redirect: false,
  formId: "70tGv7",
  data: {
    first_name: name,
    email: email,
    phone: phone,
    password: password,
    parent_id: prefix + parent_id,
    dog_name: dog_name,
    dog_breed: dog_breed,
    // dog_dob: dog_dob,
    dog_neutered: dog_neutered,
    dog_weight: dog_weight,
    dog_shape: dog_shape,
    dog_activity: dog_activity
  }
};

  CF.customer.save(customerSaveOptions)
    .then(function(errorObj) {
      if (errorObj) {
        // Handle errors
        Object.keys(errorObj).forEach(function(key) {
          console.log(key + ': ' + errorObj[key].join(', '));
        });
      } else {
        window.stop();
        console.log('Customer data saved successfully!');
        
        
        login(email, password).done(function (html) {  
          if (html.indexOf('Invalid login credentials') !== -1) {
          } else {
            var checkoutUrl = getCheckoutUrl();
            if (checkoutUrl) {
              window.location.href = checkoutUrl;
            } else { 
            }
            
          }
        });
        
      }
    })
    .catch(function(err) {
      // Error handling if the save method itself fails
      console.error("Could not save customer", err);
    });
});
});

    jQuery(function() {
      jQuery('#signupForm').click(function(event) {
        $('#saveCustomer').click();
        // $('.user-registrations').click();
        $('.loader').removeClass('hidden');
        
        // Add hidden class back after 2 seconds
        setTimeout(function() {
          $('.loader').addClass('hidden');
        }, 3500);
      });
    });
$(".add-mix-breed").click(function() {
  $(".cross-breed-container").removeClass("hidden");
  $(this).addClass("hidden");
  $(".remove-mix-breed").removeClass("hidden");
})
$(".remove-mix-breed").click(function() {
  $(".cross-breed-container").addClass("hidden");
  $(this).addClass("hidden");
  $(".add-mix-breed").removeClass("hidden");
})


// $('#petParentFullName, #petParentEmail, #petParentMobile').on('input', function() {
//   var name = $('#petParentFullName').val();
//   var email = $('#petParentEmail').val();
//   var phone = $('#petParentMobile').val();
//   if (name && email && phone) {
//     $(".dog-account").removeClass("stickynavigation-module__disabled___1GDwt");
//     $(".dog-account").find("button").removeAttr("disabled","");
//   } else {
//     $(".dog-account").addClass("stickynavigation-module__disabled___1GDwt");
//     $(".dog-account").find("button").attr("disabled","");
//   }
//   var dog_owner_name = name;
//   Cookies.set("dogOwnerName", dog_owner_name, { expires: 5 });
  
//   var dog_owner_email = email;
//   Cookies.set("dogOwnerEmail", dog_owner_email, { expires: 5 });

//   var dog_owner_phone = phone;
//   Cookies.set("dogOwnerMobile", dog_owner_phone, { expires: 5 });
// });

$('.icon-next-swiper').click(function() {
  $(".ingSwiper .swiper-button-next").click();
})
$('.icon-previous-swiper').click(function() {
  $(".ingSwiper .swiper-button-prev").click();
})

$(".atc-button").on("click", function() {
  $(".subscription-step").removeClass("active");
  $(".subscription-step").css("display", "none");
  $(".final-stepp").addClass("active");
  $(".final-stepp").css({ 'display': 'flex', 'left': '0%', 'opacity': '1', 'position': 'relative' })
})

$("span.more-details").click(function() {
  if (window.innerWidth <= 768) { // Adjust the width as per your breakpoint for mobile
    $(this).nextAll(".product-content-popup").first().removeClass("hidden");
  } else {
    $(this).nextAll(".product-desktop-container").first().removeClass("hidden");
  }
})
$(".close-popup").click(function() {
  $(".payment-mode-selection").addClass("hidden");
})
$("span.more-details").click(function() {
  if (window.innerWidth <= 768) { // Adjust the width as per your breakpoint for mobile
    $(this).nextAll(".product-content-popup").first().removeClass("hidden");
  } else {
    $(this).nextAll(".product-desktop-container").first().removeClass("hidden");
  }
})
$(".close-button").click(function() {
  $(this).parents(".product-content-popup").addClass("hidden");
})
$(".close-buttonn").click(function() {
  $(this).parents(".product-desktop-container").addClass("hidden");
})

// For managing the quantity

$('.minus-quantity').click(function() {
  var currentValue = parseInt($('.gramos-value').text());
  if (currentValue > 50) {
    $('.gramos-value').text((currentValue - 50) + 'g');
    calculateBags();
    DistributeVariantsQuantity();
  }
});

$('.plus-quantity').click(function() {
  var currentValue = parseInt($('.gramos-value').text());
  $('.gramos-value').text((currentValue + 50) + 'g');
  calculateBags();
  DistributeVariantsQuantity();
});

let bagsToSend = 0;
let discount_divider = 100 / (100 - discountt);
let discount_divider_saving = 100 / discountt;
console.log(discountt, discount_divider)

// Function to calculate the total weight and number of bags needed
function calculateBags() {
  const gramsValue = parseInt($('.gramos-value').text());
  const daysValue = parseInt($('.frequency-option').attr('data-days'));
  const totalWeight = gramsValue * daysValue;
  const bagWeight = 500;
  const bagsNeeded = Math.ceil(totalWeight / bagWeight);
  bagsToSend = bagsNeeded;
  $('.bagsToSend').text(bagsToSend);
  let price = (bagsToSend * $(".item-atc-button").parent().find("select.doggy-food-w-variant.active option:selected").data("price")) / (daysValue * 100);
  let price_per_day_flexible = price.toFixed(2);
  $('.price-per-day-flexible').text(price_per_day_flexible);
  // let price_per_day_discounted = (price / discount_divider).toFixed(2);
  let price_per_day_discounted = (price*7).toFixed(2);
  $('.price-per-day-discounted').text(price_per_day_discounted);
  // let ppprice = $(".item-atc-button").parent().find("select.doggy-food-w-variant.active option:selected").data("price") / (daysValue * 100 * discount_divider);
  let ppprice = $(".item-atc-button").parent().find("select.doggy-food-w-variant.active option:selected").data("price") / (daysValue * 100);
  $(".product-price-fixed").text((bagsToSend * ppprice * daysValue).toFixed(2));
  let subscription_price_discounted = $(".item-atc-button").parent().find("select.doggy-food-w-variant.active option:selected").data("price") / (daysValue * 100 * discount_divider_saving);
  $('.discount-final').text((bagsToSend * subscription_price_discounted * daysValue).toFixed(2));
  console.log(bagsToSend, bagWeight, price);
}
function calculateRecommendedPrice() {
  const gramsValue = parseInt($('.gramos-value').text());
  const daysValue = parseInt($('.frequency-option').attr('data-days'));
  const totalWeight = gramsValue * daysValue;
  const bagWeight = 500;
  var p_price = $(".item-atc-button").parent().find("select.doggy-food-w-variant.active option:selected").data("price");
  let price = (bagsToSend * p_price) / (daysValue * 100);
  let price_per_day = (price*7).toFixed(2);
  $('.price-per-day').text(price_per_day);
}

// For managing the frequencies

$(document).ready(function() {
  const options = [];
  let defaultIndex = 0;
  $('.selling-name label').each(function(index) {
    const optionText = $(this).text().trim();
    const weeks = parseInt(optionText) || 0;
    if (optionText !== "One-time purchase") {
      options.push({
        text: optionText,
        value: $(this).data('value'),
        days: weeks * 7,
        price: bagsToSend * $(this).data('price'),
      });
      if (weeks === 1) {
        defaultIndex = index - 1;
      }
    }
  });

  let currentIndex = defaultIndex;
  const totalOptions = options.length;

  function updateFrequencyOption() {
    const currentOption = options[currentIndex];
    $('.frequency-option').text(currentOption.text).attr('data-value', currentOption.value).attr('data-days', currentOption.days).attr('data-price', currentOption.price);
    $(`.selling-plan input[type=radio]`).prop('checked', false);
    $(`.selling-plan input[type=radio][value=${currentOption.value}]`).prop('checked', true);
    calculateBags();
    $(".delivery-frequency-text").text(currentOption.text);
    $(".frequency-number").text(currentOption.days / 7);
    $('input.variant-selection').attr('data-selling_id', currentOption.value);
  }

  $('.frequency-arrow-left').click(function() {
    currentIndex = (currentIndex - 1 + totalOptions) % totalOptions;
    updateFrequencyOption();
    DistributeVariantsQuantity();
  });

  $('.frequency-arrow-right').click(function() {
    currentIndex = (currentIndex + 1) % totalOptions;
    updateFrequencyOption();
    DistributeVariantsQuantity();
  });

  updateFrequencyOption(); // Initialize with the first option

  $("input[name=payment-selector]").change(function() {
  var payment_mode = $(this).val();
  if (payment_mode == "manual") {
    $(".frequency-option").attr("data-value", "");
    $('input.variant-selection').attr("data-selling_id", "");
  } else {
    updateFrequencyOption();
  }
})

$("input[name=payment-selectorr]").change(function() {
  var payment_modee = $(this).val();
  if (payment_modee == "manual") {
    $(".frequency-option").attr("data-value", "");
    $('input.variant-selection').attr("data-selling_id", "");
  } else {
    updateFrequencyOption();
  }
  $(".cart.next").removeClass("stickynavigation-module__disabled___1GDwt");
  $(".cart.next").find("button").removeAttr("disabled");
})
  
});

$(document).ready(function() {
  if($("input[name=payment-selectorr]").is(":checked")) {
    $(".cart.next").removeClass("stickynavigation-module__disabled___1GDwt");
    $(".cart.next").find("button").removeAttr("disabled");
  } else {
    $(".cart.next").addClass("stickynavigation-module__disabled___1GDwt");
    $(".cart.next").find("button").attr("disabled");
  }
})


// Setting allergy

 // $(document).ready(function() {
 //    const allergyCheckboxes = $('.indi-allergy input[type="checkbox"]');
 //    const ingredientCheckboxes = $('.ingredient-selector');

 //    function updateIngredients() {
 //      const selectedAllergies = [];
 //      allergyCheckboxes.each(function() {
 //        if ($(this).is(':checked')) {
 //          selectedAllergies.push($(this).val().toLowerCase());
 //        }
 //      });

 //      ingredientCheckboxes.each(function() {
 //        const ingredient = $(this).val().toLowerCase();
 //        if (selectedAllergies.includes(ingredient)) {
 //          $(this).prop('checked', false).prop('disabled', true);
 //        } else {
 //          $(this).prop('disabled', false);
 //        }
 //      });
 //    }

 //    allergyCheckboxes.change(updateIngredients);
 //    updateIngredients(); // Run on page load to initialize state
 //  });

$(document).ready(function() {
    const allergyCheckboxes = $('.yes-allergy');
    const ingredientCheckboxes = $('.ingredient-selector');
    const ingredientVariantCheckboxes = $('input.variant-selection');

    function updateIngredients() {
        // Check if the "all-allergy" checkbox is checked
        const isAllAllergyChecked = $('.all-allergy').is(':checked');

        if (isAllAllergyChecked) {
            // Disable and uncheck all ingredient selectors
            ingredientCheckboxes.prop('checked', false);
            ingredientVariantCheckboxes.prop('checked', false);
            console.log("working");
        } else {
            // Array to store selected allergies
            const selectedAllergies = allergyCheckboxes.filter(':checked').map(function() {
                return $(this).val().toLowerCase();
            }).get();

            // Enable/disable ingredient checkboxes based on allergies selected
            ingredientCheckboxes.each(function() {
                const ingredient = $(this).val().toLowerCase();
                if (selectedAllergies.includes(ingredient)) {
                    $(this).prop('checked', false);
                } else {
                    $(this).prop('checked', true);
                }
            });
            ingredientVariantCheckboxes.each(function() {
                const ingredientVariant = $(this).data("flavor").toLowerCase();
                if (selectedAllergies.includes(ingredientVariant)) {
                    $(this).prop('checked', false);
                } else {
                    $(this).prop('checked', true);
                }
            });
        }
    }

    // Attach change event handlers
    allergyCheckboxes.change(updateIngredients);
    updateIngredients(); // Run on page load to initialize state

});


function DistributeVariantsQuantity() {
  console.log(bagsToSend);
  var checkedInputs = $('input.variant-selection:checked');
  var count = checkedInputs.length;

  if (count > 0) {
    var bagsPerInput = Math.floor(bagsToSend / count);
    var remainder = bagsToSend % count; 

    checkedInputs.each(function(index) {
      var quantity = bagsPerInput + (index < remainder ? 1 : 0);
      $(this).data("quantity", quantity);
    });
  } else {
    $('input.variant-selection').data("quantity", '');
  }
}

$(".ingredient-selector").change(function() {
  updateFoodIngredients();
  DistributeVariantsQuantity();
})
$(".homepage button").click(function() {
  window.location.href = "/";
})
$("button.direct-result-button").click(function() {
  window.location.href = "/pages/confirmation";
})
$("button#confirm-button").on("click", function() {
  $(".map.next").removeClass("stickynavigation-module__disabled___1GDwt");
  $(".map.next").find("button").removeAttr("disabled");
})
$("button#change-location-button").on("click", function() {
  $(".map.next").addClass("stickynavigation-module__disabled___1GDwt");
  $(".map.next").find("button").attr("disabled","");
})















// This is script adds content to modal just using same class


document.querySelectorAll('.link001').forEach(link => {
  link.addEventListener('click', function () {
    const card = this.closest('.card001');

    if (card) {
      const modalElement = document.getElementById('modal001');
      const modalContentElement = modalElement ? modalElement.querySelector('.modalcontent001') : null;

      if (!modalContentElement) {
        console.error("Modal content area not found! Ensure #modal001 contains .modalcontent001.");
        return;
      }

      // --- Configuration for content types ---
      // 1. Classes for plain text content (e.g., title, description)
      const textContentClasses = [
        'title001',
        'desc001',
        'price001', // Your price is text content
        'maxpro',    // Assuming maxpro is plain text
        'tester001', // Assuming tester is plain text
        'vtx',
         'pqx',
         'dcx',
        'material001' // Assuming material is plain text
      ];

      // 2. Classes for innerHTML content (elements containing children, like badges)
      const innerHTMLClasses = ['badges001'];

      // 3. Classes for image elements (transferring 'src' and 'alt')
      const imageClasses = ['img001']; // Add any class here if it's on an <img> tag

      // --- START: Clearing previous content in the modal ---
      // Loop through all potential target elements in the modal and clear them
      // This is crucial to ensure clean content for each new product display.
      // Clear text content elements
      textContentClasses.forEach(className => {
          const targetEl = modalContentElement.querySelector(`.${className}`);
          if (targetEl) {
              targetEl.textContent = '';
          }
      });

      // Clear inner HTML elements
      innerHTMLClasses.forEach(className => {
          const targetEl = modalContentElement.querySelector(`.${className}`);
          if (targetEl) {
              targetEl.innerHTML = '';
          }
      });

      // Clear image elements (src and alt)
      imageClasses.forEach(className => {
          const targetEl = modalContentElement.querySelector(`img.${className}`); // Specific to IMG tag
          if (targetEl) {
              targetEl.src = '';
              targetEl.alt = '';
          }
      });
      // --- END: Clearing previous content ---


      // --- START: Transferring content from card to modal ---

      // 1. Transfer Plain Text Content
      textContentClasses.forEach(className => {
        const cardSourceElement = card.querySelector(`.${className}`);
        const modalTargetElement = modalContentElement.querySelector(`.${className}`);

        if (modalTargetElement && cardSourceElement) {
          modalTargetElement.textContent = cardSourceElement.textContent.trim();
        }
        // No 'else' needed here for clearing, as clearing is done upfront for all.
      });

      // 2. Transfer Inner HTML Content
      innerHTMLClasses.forEach(className => {
        const cardSourceElement = card.querySelector(`.${className}`);
        const modalTargetElement = modalContentElement.querySelector(`.${className}`);

        if (modalTargetElement && cardSourceElement) {
          modalTargetElement.innerHTML = cardSourceElement.innerHTML.trim();
        }
      });

      // 3. Transfer Image Source and Alt Attributes
      imageClasses.forEach(className => {
        const cardImageSource = card.querySelector(`img.${className}`); // Specific to IMG tag
        const modalImageTarget = modalContentElement.querySelector(`img.${className}`); // Specific to IMG tag

        if (modalImageTarget && cardImageSource && cardImageSource.src) {
          modalImageTarget.src = cardImageSource.src;
          modalImageTarget.alt = cardImageSource.alt || ''; // Transfer alt, default to empty
        }
      });
      // --- END: Transferring content ---


      // Finally, open the modal
      if (modalElement) {
        modalElement.style.display = 'flex';
      }
    } else {
      console.warn("Clicked link001, but no parent card001 found. Modal won't open for this trigger.");
    }
  });
});

// --- Modal close functions (no changes needed here) ---
function closeModal() {
  const modalElement = document.getElementById('modal001');
  if (modalElement) {
    modalElement.style.display = 'none';
  }
}

window.onclick = function (e) {
  const modalElement = document.getElementById('modal001');
  if (modalElement && e.target === modalElement) {
    closeModal();
  }
};










  function showCounter(btn) {
    const actionBox = btn.closest('.action001');
    actionBox.classList.add('show001');
  }

  function increment(btn) {
    const counter = btn.nextElementSibling;
    let count = parseInt(counter.textContent);
    counter.textContent = count + 1;
  }

  function decrement(btn) {
    const counter = btn.previousElementSibling;
    let count = parseInt(counter.textContent);
    if (count <= 1) {
      btn.closest('.action001').classList.remove('show001');
    } else {
      counter.textContent = count - 1;
    }
  }






        document.addEventListener('DOMContentLoaded', function() {
            const sections = document.querySelectorAll('.expandable-section');

            sections.forEach(section => {
                const header = section.querySelector('.expandable-header');

                // Make the "ANÁLISIS GARANTIZADO" section open by default
                if (section.id === 'analisis-garantizado') {
                    section.classList.add('open');
                }

                header.addEventListener('click', function() {
                    section.classList.toggle('open');
                });
            });
        });







document.addEventListener('DOMContentLoaded', () => {
    const clearCartButtons = document.querySelectorAll('.atc-button');

    if (clearCartButtons.length > 0) {
        clearCartButtons.forEach(button => {
            button.addEventListener('click', event => {
                event.preventDefault();

                fetch('/cart/clear.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                })
                .then(response => {
                    if (!response.ok) {
                        return response.json().then(errorData => {
                            throw new Error(errorData.message || `Failed to clear cart. HTTP status: ${response.status} ${response.statusText}`);
                        }).catch(() => {
                            throw new Error(`Failed to clear cart. HTTP status: ${response.status} ${response.statusText}`);
                        });
                    }
                    return response.json();
                })
                .then(() => {
                    const cartCountElements = document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count, .js-cart-count, .site-header__cart-count, .count');
                    cartCountElements.forEach(countEl => {
                        countEl.textContent = '0';
                        countEl.setAttribute('aria-hidden', 'true');
                        countEl.classList.remove('active');
                    });

                    const cartDrawer = document.querySelector('[data-cart-drawer], .ajax-cart-drawer, #CartDrawer');
                    if (cartDrawer) {
                        cartDrawer.classList.remove('is-active', 'active');
                        const cartItemsContainer = cartDrawer.querySelector('[data-cart-items], .cart__items, .mini-cart-body');
                        if (cartItemsContainer) {
                            cartItemsContainer.innerHTML = '';
                        }
                    }

                    console.log('Cart successfully cleared!'); // Log success to console
                })
                .catch(error => {
                    console.error('Error clearing cart:', error); // Log error to console
                });
            });
        });
    }
});
